import t from './Oprationalcp.type';
import * as oprationalcp from '../../../services/oprationalcp.service';
import { toasterMsg } from '../../../Components/Toaster/Toaster';

export const fetchUnArchiveCardData = (params) => async (dispatch) => {
  try {
    const res = await oprationalcp.fetchAllCards(params);
    if (res?.code === 200) {
      await dispatch({
        type: t.GET_UNARCHIVED_CARDS,
        payload: res.data,
      });
      return true;
    }
    toasterMsg(res.data.errMsg.toString(), 'danger');
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const fetchEditData = (params) => async (dispatch) => {
  try {
    const res = await oprationalcp.fetchSingleCards(params);
    if (res?.code === 200) {
      await dispatch({
        type: t.GET_EDIT_CARDS_DATA,
        payload: res.data,
      });
      return true;
    }
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const fetchSuppliers = (params) => async (dispatch) => {
  try {
    const res = await oprationalcp.fetchAllSuppliers(params);
    if (res?.code === 200) {
      await dispatch({
        type: t.GET_ALL_SUPPLIERS,
        payload: res.data,
      });
      return true;
    }
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const fetchRowColumnDataforOP = (params) => async (dispatch) => {
  try {
    const res = await oprationalcp.fetchDynamicRowColumnDetails(params);
    if (res?.code === 200) {
      await dispatch({
        type: t.GET_ALL_ROW_COLUMDATA,
        payload: res.data,
      });
    } else {
      toasterMsg(res.data.errMsg.toString(), 'danger');
    }
    return true;
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const addCard = (params, transactionMsg) => async () => {
  try {
    const res = await oprationalcp.addCardToCP(params);
    if (res?.code === 200) {
      const msg = transactionMsg(`OPRATIONAL_CP.${res.message}`);
      toasterMsg(msg, 'success');
      return res.data;
    }
    toasterMsg(transactionMsg(res?.data?.errMsg), 'danger');
    return false;
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const addRowsToCard = (params, transactionMsg) => async () => {
  try {
    const res = await oprationalcp.addRowsToCP(params);
    if (res?.code === 200) {
      const msg = transactionMsg(`OPRATIONAL_CP.${res.message}`);
      toasterMsg(msg, 'success');
      return true;
    }
    toasterMsg(transactionMsg(res?.data?.errMsg), 'danger');
    return false;
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const addColumnsToCard = (params, transactionMsg) => async () => {
  try {
    const res = await oprationalcp.addColumnsToCP(params);
    if (res?.code === 200) {
      const msg = transactionMsg(`OPRATIONAL_CP.${res.message}`);
      toasterMsg(msg, 'success');
      return true;
    }
    toasterMsg(transactionMsg(res?.data?.errMsg), 'danger');
    return false;
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const getRowsForCard = (params) => async (dispatch) => {
  try {
    const res = await oprationalcp.getRowsofCP(params);
    if (res?.code === 200) {
      await dispatch({
        type: t.GET_ALL_ROWS,
        payload: res.data.data,
      });
      return true;
    }
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const getColumnsForCard = (params) => async (dispatch) => {
  try {
    const res = await oprationalcp.getColumnsofCP(params);
    if (res?.code === 200) {
      await dispatch({
        type: t.GET_ALL_COLUMNS,
        payload: res.data,
      });
      return true;
    }
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const deleteCard = (params, transactionMsg) => async () => {
  try {
    const res = await oprationalcp.deleteOprationalCP(params);
    if (res?.code === 200) {
      const msg = transactionMsg(`OPRATIONAL_CP.${res.message}`);
      toasterMsg(msg, 'success');
      return true;
    }
    toasterMsg(res?.data?.errMsg, 'danger');
    return false;
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const deleteRowsCard = (params, transactionMsg) => async () => {
  try {
    const res = await oprationalcp.deleteOprationalCPRows(params);
    if (res?.code === 200) {
      const msg = transactionMsg(`OPRATIONAL_CP.${res.message}`);
      toasterMsg(msg, 'success');
      return true;
    }
    toasterMsg(res?.data?.errMsg, 'danger');
    return false;
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const deleteColumnsCard = (params, transactionMsg) => async () => {
  try {
    const res = await oprationalcp.deleteOprationalCPColumns(params);
    if (res?.code === 200) {
      const msg = transactionMsg(`OPRATIONAL_CP.${res.message}`);
      toasterMsg(msg, 'success');
      return true;
    }
    toasterMsg(res?.data?.errMsg, 'danger');
    return false;
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const clearReducer = () => async (dispatch) => {
  try {
    await dispatch({
      type: t.CLEAR_REDUCER,
    });
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const addManualData = (params, transactionMsg) => async () => {
  try {
    const res = await oprationalcp.manualDataAdded(params);
    if (res?.code === 200) {
      const msg = transactionMsg(`OPRATIONAL_CP.${res.message}`);
      toasterMsg(msg, 'success');
      return true;
    }
    toasterMsg(res?.data?.errMsg, 'danger');
    return false;
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const duplicateOperationalCP = (params, transactionMsg) => async () => {
  try {
    const res = await oprationalcp.duplicateOCP(params);
    if (res?.code === 200) {
      const msg = transactionMsg(`OPRATIONAL_CP.${res.message}`);
      toasterMsg(msg, 'success');
      return res.data;
    }
    toasterMsg(transactionMsg(res?.data?.errMsg), 'danger');
    return false;
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const lastOpened = (params) => async () => {
  try {
    const res = await oprationalcp.lastOpenedModal(params);
    if (res?.code === 200) {
      return true;
    }
    toasterMsg(res?.data?.errMsg, 'danger');
    return false;
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const getActiveColumnsofCP = (params) => async () => {
  try {
    const res = await oprationalcp.getActiveColumnsofCP(params);
    if (res?.code === 200) {
      return res.data;
    }
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};
export const downloadOCPExcel = (params, transactionMsg) => async () => {
  try {
    const res = await oprationalcp.downloadOCPExcelService(params); // API
    if (res) {
      toasterMsg(transactionMsg(res.message), 'success');
      return res;
    }
  } catch (error) {
    toasterMsg(error.toString(), 'danger');
  }
  return true;
};
